<template>
    <div class="page">
        <div class='page-content'>
            <div class='page-tool-bar'>
                <div class='el-btn-group'></div>
                <div class='icon-group'>
                    <!-- <span
                        title='搜索'
                        class='icon-box'
                        @click='toggleSearch'
                    >
                        <Icon color='#606266'>
                            <Search />
                        </Icon>
                    </span> -->
                    <span
                        class='icon-box'
                        title='刷新'
                        @click='refreshActivityList'
                    >
                        <Icon color='#606266'>
                            <Refresh />
                        </Icon>
                    </span>
                </div>
            </div>
            <!-- 列表 -->
            <el-table
                max-height='100%'
                :data='tableData.list'
                row-key='id'
                border
                v-loading='tableLoading'
                :header-row-style="{height: '10px'}"
                :header-cell-style="{padding: '10px'}"
                :row-style="{height: '9px'}"
                :cell-style="{padding: '9px'}"
                size='small'
            >
                <el-table-column align='center' prop='batchNo' label='批次号'></el-table-column>
                <el-table-column align='center' prop='companyAmount' label='公司投入金额'></el-table-column>
                <el-table-column align='center' prop='fixedRatio' label='固定比例'></el-table-column>
                <el-table-column align='center' prop='totalActualAmount' label='实际分配总金额'></el-table-column>
                <el-table-column align='center' prop='userCount' label='分配用户数'></el-table-column>
                <el-table-column align='center' label='操作'>
                    <template slot-scope='scope'>
                        <el-button type='text' size='small' @click='handleDetail(scope.row)'>详情</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class='pagination-box'>
                <el-pagination
                    @size-change='(size) => { queryForm.pageSize = size; getTableData(); }'
                    @current-change='(page) => { queryForm.pageNum = page; getTableData(); }'
                    :current-page='queryForm.pageNum'
                    :page-sizes='[10, 20, 50, 100]'
                    :page-size='queryForm.pageSize'
                    layout='total, sizes, prev, pager, next, jumper'
                    background
                    :total='tableData.total'>
                </el-pagination>
            </div>
        </div>
        <!-- 详情弹窗 -->
        <el-dialog
            :visible.sync='detailDialogVisible'
            title='详情'
            width='50%'
            :before-close='handleCloseDetailDialog'
        >
            <div class='detail-dialog-content'>
                <el-table
                    :data='detailDialogData'
                    border
                    size='small'
                >
                    <el-table-column align='center' prop='userId' label='用户ID'></el-table-column>
                    <el-table-column align='center' prop='depositAmount' label='该用户存人金额'></el-table-column>
                    <el-table-column align='center' prop='multiplier' label='该用户倍数'></el-table-column>
                    <el-table-column align='center' prop='actualAmount' label='实际获得金额'></el-table-column>
                </el-table>
            </div>
            <div slot='footer' class='dialog-footer'>
                <el-button @click='handleCloseDetailDialog'>取消</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import { Refresh, Search } from '@v2icons/tabler';
import { post, postJson, get } from '@/utils/request.js';

export default {
    name: 'ConsumptionVoucherPoolAllocation',
    data() {
        return {
            queryForm: {
                page: 1,
                pageSize: 10
            },
            tableData: {
                list: [],
                total: 0
            },
            tableLoading: false,
            detailDialogVisible: false,
            detailDialogData: []
        };
    },
    components: {
        Refresh,
        Search
    },
    created() {
        this.getTableData();
    },
    methods: {
        getTableData() {
            this.tableLoading = true;
            get(`/shop/admin/coupon-deposit/distribute/findList`, this.queryForm).then((res) => {
                this.tableLoading = false;
                if (res.success) {
                    this.tableData.list = res.page.list;
                    this.tableData.total = res.page.total;
                } else {
                    this.$message.error(res.msg);
                }
            }).finally(() => {
                this.tableLoading = false;
            });
        },
        refreshActivityList() {
            this.queryForm.page = 1;
            this.getTableData();
        },
        handleDetail(row) {
            get(`/shop/admin/coupon-deposit/distribute/detail/${row.id}`).then((res) => {
                if (res.success) {
                    console.log("res======>", res);
                    this.detailDialogData = res.details;
                    this.detailDialogVisible = true;
                } else {
                    this.$message.error(res.msg);
                }
            })
        },
        handleCloseDetailDialog() {
            this.detailDialogVisible = false;
            this.detailDialogData = [];
        }
    }
};
</script>
<style scoped lang="scss"></style>